import React from 'react';
import * as PropTypes from 'prop-types';
import Select from '../Select';
//import { useFieldFast } from '../../hooks';

//const TYPE_OTHER = 'Sonstige';
//const splitValueFoobar = (types1, value) => {
//    if (!value) {
//        return ['', ''];
//    }
//    return types1.includes(value) ? [value, ''] : [TYPE_OTHER, value];
//};

const FranchiseTypeSelect = ({ name, prefix, label, fullWidth, types, disabled }) => {
    const typeOptions = [
        { value: '', label: 'Typ auswählen' },
        ...types.map((type) => ({ value: type, label: type })),
    ];

    //const [{ value }] = useFieldFast(name);
    //const [type, detail] = useMemo(() => splitValueFoobar(types, value), [types, value]);

    return (
        <Select
            options={typeOptions}
            name={name}
            prefix={prefix}
            label={label}
            fullWidth={fullWidth}
            disabled={disabled}
        />
    );
};

FranchiseTypeSelect.propTypes = {
    name: PropTypes.string.isRequired,
    prefix: PropTypes.string,
    label: PropTypes.string,
    fullWidth: PropTypes.bool,
    disabled: PropTypes.bool,
};

FranchiseTypeSelect.defaultProps = {
    prefix: null,
    label: null,
    fullWidth: false,
    disabled: false,
    types: ['Light', 'Expert'],
};

export default FranchiseTypeSelect;
